/**
 * Use cases API slice.
 * Leaf module (Perf 3.1.b/e Step 6). Pulls only the shared chokepoint from
 * ./client; never imports a sibling @/lib/api slice.
 *
 * Powers the public SEO pages at /use-cases and /use-cases/[slug].
 */
import { fetchWithAuth } from './client';
import { useCasePublicCopy } from '@/content/useCasePublicCopy';

function publicResponse(data) {
  return {
    ...data,
    ...(data?.useCases ? { useCases: data.useCases.map(useCasePublicCopy) } : {}),
    ...(data?.useCase ? { useCase: useCasePublicCopy(data.useCase) } : {}),
    ...(data?.relatedUseCases ? { relatedUseCases: data.relatedUseCases.map(useCasePublicCopy) } : {}),
  };
}

export const useCasesApi = {
  list: async () => publicResponse(await fetchWithAuth('/json/use-cases')),

  getBySlug: async (slug) => {
    return publicResponse(await fetchWithAuth(`/json/use-cases/${encodeURIComponent(slug)}`));
  },
};
